import { render, staticRenderFns } from "./CVExample.vue?vue&type=template&id=9c5b24be&"
import script from "./CVExample.vue?vue&type=script&lang=ts&"
export * from "./CVExample.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports